import * as THREE from 'three'

export const getBoundingBox = (object: THREE.Object3D) =>
  new THREE.Box3().setFromObject(object)

export const getBoundingSphere = (object: THREE.Object3D) => {
  const { min, max } = getBoundingBox(object)
  const minDis = Math.sqrt(min.x ** 2 + min.y ** 2 + min.z ** 2)
  const maxDis = Math.sqrt(max.x ** 2 + max.y ** 2 + max.z ** 2)
  return {
    center: { x: 0, y: 0, z: 0 },
    radius: minDis > maxDis ? minDis : maxDis,
  }
}
